export function createDiagnosticsExportButton(
  doc: Document,
  testId: string,
  request?: () => Promise<string | undefined>,
): HTMLButtonElement {
  const button = doc.createElement('button');
  button.type = 'button';
  button.dataset.testid = testId;
  button.className = 'hud-pause-debug-btn';
  button.textContent = 'Выгрузить логи в файл';
  button.addEventListener('click', () => {
    if (!request || button.disabled) return;
    button.disabled = true;
    void request().then(
      (jsonl) => {
        button.disabled = false;
        if (!jsonl) {
          button.textContent = 'Пока нет записанных боёв';
          return;
        }
        const url = URL.createObjectURL(new Blob([jsonl], { type: 'application/jsonl' }));
        const anchor = doc.createElement('a');
        anchor.href = url;
        anchor.download = `ai-diagnostics-${Date.now().toString(36)}.jsonl`;
        doc.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
        button.textContent = 'Выгрузить логи в файл';
      },
      (error: unknown) => {
        button.disabled = false;
        button.textContent = 'Не удалось выгрузить. Повторить';
        console.warn('Diagnostics export failed', error);
      },
    );
  });
  return button;
}

export function showDiagnosticsWarning(doc: Document, message: string): void {
  let warning = doc.querySelector<HTMLElement>('.diagnostics-storage-warning');
  if (!warning) {
    warning = doc.createElement('div');
    warning.className = 'diagnostics-storage-warning';
    warning.setAttribute('role', 'alert');
    doc.body.appendChild(warning);
  }
  warning.textContent = message;
}
